import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./RecentActivities.css";

import reliefImg from "../assets/slide4.png";
import skillImg from "../assets/slide.png";   
import womenImg from "../assets/slide7.png";   

const activities = [
  {
    id: 1,
    title: "Relief Distribution",
    desc: "Providing relief materials to flood and earthquake-affected people.",
    img: reliefImg,
    delay: 100,
  },
  {
    id: 2,
    title: "Skill Development",
    desc: "Training youth through skill development programs for self-reliance.",
    img: skillImg,
    delay: 200,
  },
  {
    id: 3,
    title: "Women Empowerment",
    desc: "Organizing seminars and training programs to empower women and children.",
    img: womenImg,
    delay: 300,
  },
];

const RecentActivities = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <section className="activities-section-home" id="recent-activities">
      <div className="activities-container-home">
        <h2 className="activities-title-home" data-aos="fade-up">
          Our Recent <span>Activities</span>
        </h2>

        <div className="activities-grid-home">
          {activities.map((act) => (
            <div
              className="activities-card-home"
              key={act.id}
              data-aos="fade-up"
              data-aos-delay={act.delay}
            >
              <div className="activities-image-home">
                <img src={act.img} alt={act.title} />
              </div>
              <div className="activities-content-home">
                <h3>{act.title}</h3>
                <p>{act.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentActivities;
